import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
import { SessionActivityService } from './services/session-activity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'frontend';

  private profileSub: Subscription | null = null;

  constructor(
    private readonly authService: AuthService,
    private readonly sessionActivity: SessionActivityService,
  ) {}

  ngOnInit(): void {
    // Start session keepalive once the profile is loaded and the user is signed in.
    this.profileSub = this.authService.profile$.subscribe((profile) => {
      if (profile) {
        this.sessionActivity.start();
      }
    });
  }

  ngOnDestroy(): void {
    this.profileSub?.unsubscribe();
  }
}
